const Share = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.375 14.25C15.3695 14.25 14.4695 14.6895 13.8508 15.3855L10.4933 13.2867C10.8308 12.4641 10.8344 11.5359 10.4933 10.7133L13.8508 8.61445C14.4695 9.31055 15.3695 9.75 16.375 9.75C18.2383 9.75 19.75 8.23828 19.75 6.375C19.75 4.51172 18.2383 3 16.375 3C14.5117 3 13 4.51172 13 6.375C13 6.83203 13.0914 7.26445 13.2531 7.66172L9.89569 9.76055C9.28046 9.06445 8.38046 8.625 7.37499 8.625C5.51172 8.625 4 10.1367 4 12C4 13.8633 5.51172 15.375 7.37499 15.375C8.38046 15.375 9.28046 14.9355 9.89921 14.2395L13.2566 16.3383C13.0914 16.7355 13.0035 17.168 13.0035 17.625C13.0035 19.4883 14.5152 21 16.3785 21C18.2418 21 19.7535 19.4883 19.7535 17.625C19.75 15.7617 18.2383 14.25 16.375 14.25ZM16.375 4.125C17.616 4.125 18.625 5.13398 18.625 6.375C18.625 7.61602 17.616 8.625 16.375 8.625C15.134 8.625 14.125 7.61602 14.125 6.375C14.125 5.13398 15.134 4.125 16.375 4.125ZM7.37499 14.25C6.13398 14.25 5.125 13.241 5.125 12C5.125 10.759 6.13398 9.75 7.37499 9.75C8.61601 9.75 9.62499 10.759 9.62499 12C9.62499 13.241 8.61601 14.25 7.37499 14.25ZM16.375 19.875C15.134 19.875 14.125 18.866 14.125 17.625C14.125 16.384 15.134 15.375 16.375 15.375C17.616 15.375 18.625 16.384 18.625 17.625C18.625 18.866 17.616 19.875 16.375 19.875Z"
      fill="#646464"
    />
  </svg>
)

export default Share
